import { AfterViewInit, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';

import { opacityAnimation } from '../../../animations/opacity.animation';
import { ColumnInfo } from '../../../shared/models/column-info.type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PhotographerService } from '../../../services/photographer.service';
import { OrdersListSchema } from '../../../models/common/orders-list-schema.model';
import { OrderListItem } from '../../../models/common/order-list-item.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'bt-photographer-orders',
  templateUrl: './photographer-orders.component.html',
  styleUrls: ['./photographer-orders.component.scss'],
  animations: [opacityAnimation]
})
export class PhotographerOrdersComponent implements OnInit, AfterViewInit {

  @ViewChild('orderDueDateColumn') orderDueDateColumn: any;

  readonly #destroyRef = inject(DestroyRef);
  readonly #photographerService = inject(PhotographerService);
  readonly #route = inject(ActivatedRoute);
  readonly photographerOrdersLoader = 'photographerOrdersLoader';

  public orderColumns: Array<ColumnInfo> = [];

  photographerOrders: OrdersListSchema<OrderListItem> = { orders: [], total: 0 };


  public ngOnInit() {
    this.getOrdersHistory(this.#route.params['_value']['photographerId'])
  }

  ngAfterViewInit(): void {
    this.orderColumns = [
      { title: 'Numero Ordine', width: undefined, key: 'orderNumber' },
      { title: 'Status', width: undefined, key: 'orderStatusName' },
      { title: 'Data di Scadenza', width: undefined, key: 'dueDate', template: this.orderDueDateColumn },
    ]
  }

  getOrdersHistory(photographerId: number) {
    // this.#photographerService
    //   .getOrdersByPhotographerId(0, 10, photographerId.toString(), false, null, this.photographerOrdersLoader)
    //   .pipe(takeUntilDestroyed(this.#destroyRef))
    //   .subscribe({
    //     next: (data) => {
    //       this.photographerOrders = data;
    //     }
    //   });
  }


}
